/*
  Storefront brand, fixed at build time by REACT_APP_BRAND (set per Railway
  service, defaulted in craco.config.js). XPNSR and LetsCampaign are one
  codebase: anything the workspace shows that names a brand comes from here.
*/

import { LetsCampaignMark } from './components/LetsCampaignLogo';

const KEY = process.env.REACT_APP_BRAND === 'letscampaign' ? 'letscampaign' : 'xpnsr';

const BRANDS = {
  xpnsr: {
    key: 'xpnsr',
    name: 'XPNSR Tracker',
    sidebarLogo: 'xpnsr.',
    // Image mark before the sidebar name; null keeps the pulsing dot.
    logoMark: null,
    siteUrl: 'https://xpnsr.tech',
    ctaHref: 'https://xpnsr.tech/book-demo.html',
    ctaLabel: 'Book Demo',
    supportEmail: 'support@xpnsr.tech',
    // XPNSR has sibling products (Expense, CBN), so it shows the switcher.
    // Only the tracker is live, so no product switcher (Expense and CBN are "coming soon" on the site).
    productSwitcher: false,
    // Terminal-style labels ("// navigate", lower-case crumbs).
    // Same calm, sentence-case labels as xpnsr.tech.
    terminalLabels: false,
    navGroupsClosedByDefault: false,
    // The terminal look is designed dark first; Light stays one click away.
    defaultTheme: 'dark',
  },
  letscampaign: {
    key: 'letscampaign',
    name: 'LetsCampaign',
    sidebarLogo: 'LetsCampaign',
    logoMark: LetsCampaignMark,
    siteUrl: 'https://letscampaign.com',
    ctaHref: 'https://letscampaign.com/en/contact',
    ctaLabel: 'Talk to us',
    supportEmail: 'support@letscampaign.com',
    productSwitcher: false,
    terminalLabels: false,
    navGroupsClosedByDefault: true,
    defaultTheme: 'system',
  },
};

const BRAND = BRANDS[KEY];

// Rewrites product names in UI copy. Technical identifiers stay untouched:
// the xpnsr_vid cookie, window.XPNSR, xpnsr-* keys and similar are real
// names the customer has to type, so only standalone words are replaced.
const RULES = {
  xpnsr: [],
  letscampaign: [
    [/XPNSR Tracker/g, 'LetsCampaign'],
    [/xpnsr\.tech/g, 'letscampaign.com'],
    [/(^|[^\w.$/-])(?:XPNSR|xpnsr)(?![\w(/-]|\.\w)/g, '$1LetsCampaign'],
  ],
};

export function rebrand(text, key = KEY) {
  if (typeof text !== 'string') return text;
  const rules = RULES[key] || [];
  let out = text;
  for (const [re, replacement] of rules) out = out.replace(re, replacement);
  return out;
}

export function brandText(text) {
  return KEY === 'xpnsr' ? text : rebrand(text, KEY);
}

export default BRAND;
